// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// //Dev
// export const environment =
// {
//   production: false,
//   apiBase: 'http://localhost:50742', 
//   PingEnabled: fasle,
//   isExternalUser: false
// };

// QA and Production
export const environment =
{
 production: true,
 apiBase: '',
 PingEnabled: true,
 isExternalUser: false
};